module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "attach-customer"
  }, [_c('dl', {
    staticClass: "attach-customer-body dl-horizontal"
  }, [_c('dt', [_vm._v(_vm._s(_vm.labelText) + ":")]), _vm._v(" "), (!_vm.isDataLoaded) ? _c('dd', [_c('div', {
    staticClass: "loading loading-left loading-sm"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.relations), function(relation) {
    return (_vm.isDataLoaded) ? [_c('dd', [(_vm.customerLink(relation.id)) ? _c('a', {
      attrs: {
        "href": _vm.customerLink(relation.id)
      }
    }, [_vm._v(_vm._s(relation[_vm.getAnchor()]))]) : _vm._e(), _vm._v(" "), (!_vm.customerLink(relation.id)) ? [_vm._v(_vm._s(relation[_vm.getAnchor()]))] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "clickable glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          _vm.removeRelation(relation.id)
        }
      }
    })], 2)] : _vm._e()
  }), _vm._v(" "), (_vm.isDataLoaded) ? [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddForm),
      expression: "!showAddForm"
    }],
    on: {
      "click": function($event) {
        _vm.addModeOn()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Add New")]), _vm._v(" "), _c('span', {
    staticClass: "clickable glyphicon glyphicon-plus",
    on: {
      "click": function($event) {
        _vm.removeRelation(_vm.relation.id)
      }
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddForm),
      expression: "showAddForm"
    }]
  }, [_c('autocomplete', {
    ref: "autocomplete",
    attrs: {
      "debounce": _vm.debounce,
      "placeholder": _vm.getPlaceholder(),
      "url": "#",
      "onSelect": _vm.addRelation,
      "onShouldGetData": _vm.getOptions,
      "anchor": _vm.getAnchor(),
      "label": "id"
    }
  })], 1)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ffc7670"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/AttachCustomer.vue
// module id = 1098
// module chunks = 0